import Vue from 'vue'
import moment from 'moment-timezone'
import VueMoment from 'vue-moment'
require('moment/locale/es')

Vue.use(VueMoment, {
  moment
})
